export const addDebuggingData = (key: string, data: any) => {
  if (!window.debuggingData) {
    window.debuggingData = {}
  }

  window.debuggingData[key] = data
}
